export default __webpack_public_path__ + "static/media/slice-background.c4c219f7.jpg";